export default __webpack_public_path__ + "static/media/karen-postit-bg.50f6aead.png";